import { RestClient, RequestResponse } from "@infrastructure/clients/http/clients/base/rest.client";
import { CommonDto } from "@infrastructure/clients/http/common.dto";
import { BASE_URL } from "@infrastructure/clients/http/config";
import { ServiceType } from "@domain/enums/machine.enums";
import {
  MachineListResponseSchema,
  MachineItemResponseSchema,
  FilterMachinesRequestSchema,
  FilteredMachinesResponseSchema
} from "@infrastructure/clients/http/clients/machine.schemas";
import * as z from "zod";

class MachineClientClass extends RestClient {
  baseUrl = BASE_URL;

  async getMachines(): Promise<RequestResponse<z.infer<typeof MachineListResponseSchema>>> {
    const result = await this.request("GET", "/api/machines");
    return this.validateResponse(result, CommonDto.withStatus(MachineListResponseSchema));
  }

  async getMachineById(id: string | number): Promise<RequestResponse<z.infer<typeof MachineItemResponseSchema>>> {
    const result = await this.request("GET", `/api/machines/${id}`);
    return this.validateResponse(result, CommonDto.withStatus(MachineItemResponseSchema));
  }

  async getMachinesByFilter(service_types: ServiceType[], only_available: boolean = true): Promise<RequestResponse<z.infer<typeof FilteredMachinesResponseSchema>>> {
    const result = await this.request(
      "POST",
      "/api/machines/filter",
      {
        jsonPayload: { service_types, only_available },
      }
    );
    return this.validateResponse(result, CommonDto.withStatus(FilteredMachinesResponseSchema));
  }
}

export class MachineClient extends MachineClientClass {}
